<template>
<a class="evento" :href="url">
  <div class="day">
    <div class="daywrapper">
      <span class="dia">{{ mes }}</span>
      <span class="mes">{{ dia }}</span>
    </div>
  </div>
  <div class="info">
    <p class="titulo">{{ titulo }}</p>
    <p class="local">{{ local }}</p>
  </div>
</a>
</template>

<script>
export default {
  name: "Evento",
  props:["titulo","local","dia","mes","url"],
}
</script>

<style scoped>
.evento{
  display: flex;
  flex-direction: row;
  color: #454648;
}

.evento:hover{
  background-color: #e8e8ea;
  background-color: #eae9e9;
}

.evento:hover p {
  color: black;
}



.day{
  padding: 5px;
}

.daywrapper{
  color:white;
  background-color: #080647;
  padding: 5px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 58px;
}

.dia{
  font-family: Montserrat;
}
.mes{
  font-family: "Montserrat SemiBold";
}

.daywrapper span{
  display: block;
  text-align: center;
}

.info{
  margin-top: 9px;
  margin-left: 15px;
}

.titulo{
  font-family: "Montserrat SemiBold";
  margin-bottom: 5px;
}

.local{
  font-family: "PT Sans";
  color: #454648;
}

@media (max-width: 1400px) {

  .info {
    margin-top: 0px;
  }


}

@media (max-width: 767px) {

  .titulo {
    font-size: 15px;
    line-height: 1.4;
  }

  .local {
    font-size: 13px;
  }



  }










</style>